import React from 'react';
import { Box } from '@mui/material';

const SidebarCountBadge = ({ count, color = '#e53e3e', size = 'small' }) => {
  if (count === 0) return null;
  
  const sizeStyles = {
    small: {
      fontSize: '0.75rem',
      minWidth: '18px',
      height: '18px',
      padding: '2px 6px',
    },
    medium: {
      fontSize: '0.8rem',
      minWidth: '20px', 
      height: '20px',
      padding: '3px 7px',
    }
  };

  return (
    <Box
      sx={{
        backgroundColor: color,
        color: 'white',
        borderRadius: '10px',
        textAlign: 'center',
        lineHeight: 1,
        fontWeight: 'bold',
        boxShadow: '0 1px 3px rgba(0,0,0,0.3)',
        marginLeft: 'auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        ...sizeStyles[size]
      }}
    >
      {count > 99 ? '99+' : count}
    </Box>
  );
};

export default SidebarCountBadge;
